<ng-container *ngIf="visible">
    <div class="footer-button">
        <button pButton type="button" label="Annuler" class="btn-annuler" (click)="onCancelCreateMovePoteau()"></button>
        <button pButton type="button" label="Enregistrer" class="btn-enregistrer"
            (click)="onSaveCreateMovePoteau()"></button>
    </div>
</ng-container>
